<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode }">
    <Navbar />
    <main id="main-content" class="app-main" tabindex="-1">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/Footer.vue';
import Navbar from '@/components/Navbar.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: { Navbar, AppFooter },
  computed: {
    ...mapGetters(['isDarkMode']),
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background: var(--md-sys-color-background);
  color: var(--md-sys-color-on-background);
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--md-sys-color-background);
  color: var(--md-sys-color-on-background);
  transition:
    background-color var(--md-sys-motion-emphasized),
    color var(--md-sys-motion-emphasized);
}

.app-main {
  flex: 1;
  width: 100%;
  max-width: var(--app-content-max-width);
  margin: 0 auto;
  padding: 24px var(--app-page-padding) 40px;
}

@media (max-width: 768px) {
  .app-main {
    padding: 16px var(--app-page-padding) 104px;
  }
}
</style>
